import { getCommonApplicationQueryOptions } from '@src/features/common-application/api/get-common-application';
import { getResumeStepPath } from '@src/features/common-application/utils/resume-step';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated-chromeless/common-application/',
)({
  loader: async ({ context }) => {
    // Loaders for matched routes start in parallel, so the parent's copy of this
    // query may still be in flight. On a Rails handoff the cache is cold, and
    // reading it without awaiting would resume every user at the first step.
    // ensureQueryData shares the parent's in-flight request, so this costs no
    // extra round trip.
    const application = await context.queryClient.ensureQueryData(
      getCommonApplicationQueryOptions,
    );
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/common-application/$stepPath',
      params: { stepPath: getResumeStepPath(application.uuid) },
      // Drop ?entry=onboarding so a bookmark or back-navigation cannot silently
      // re-enter the wizard.
      search: {},
    });
  },
});
